module.exports = __webpack_public_path__ + "files/af52dfeab1d66b87d17b0cbff4016726.png";